import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PRODUCT_SELECTION_URL } from '../constants/product.constants';
import { ProductAccessService } from '../services/product-access.service';

/**
 * Guard of the selection page. The page only opens while a multi-product user (or a user
 * with no openable product) has not chosen yet; everyone else goes to their product.
 */
export const productSelectionGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const productAccessService = inject(ProductAccessService);

  const entryUrl = await productAccessService.resolveEntryUrl();
  return entryUrl === PRODUCT_SELECTION_URL ? true : router.parseUrl(entryUrl);
};
